<template>
  <div class="car-footer">
    <div class="content">
      <div class="cnt1">
        <h3>华谊兄弟南京电影文化有限公司</h3>
        <p>客服热线：400 1388 518</p>
        <!-- <p>电话：0731-88609877</p> -->
        <p>地址：江苏省南京市江宁区秣陵街道白沟路</p>
      </div>
      <div class="cnt2">
        <h3>关注</h3>
        <div class="gz-cnt">
          <ul>
            <li @click="tolink('小镇概述')">小镇概述</li>
            <li @click="tolink('在线预订')">在线预订</li>
            <li @click="tolink('游玩攻略')">游玩攻略</li>
          </ul>
          <ul>
            <li @click="tolink('小镇导览')">小镇导览</li>
            <li @click="tolink('小镇动态')">小镇动态</li>
            <li @click="tolink('出行锦囊')">出行锦囊</li>
          </ul>
        </div>
      </div>
      <div class="cnt2">
        <h3>链接</h3>
        <div class="gz-cnt">
          <ul>
            <li @click="tolink('乐园须知')">乐园须知</li>
            <li @click="tolink('使用条款')">使用条款</li>
            <li @click="tolink('法律声明')">法律声明</li>
          </ul>
          <ul>
            <li @click="tolink('隐私政策')">隐私政策</li>
          </ul>
        </div>
      </div>
      <div class="cnt2">
        <h3>分享</h3>
        <div class="fx-cnt">
          <ul>
            <li @mouseenter="showewm(true)" @mouseleave="showewm(false)">
              <img src="../assets/images/carmer/wx.png" />
            </li>
            <!-- <li><img src="../assets/images/carmer/xl.png" /></li> -->
          </ul>
          <div class="erwm" v-if="isShow">
            <img src="../assets/images/carmer/ewm.png" />
          </div>
        </div>
      </div>
    </div>
    <div class="cr-ft">版权所有：@2020南京华谊电影小镇文化产业有限公司 |
       <a href="https://beian.miit.gov.cn/#/Integrated/index " style="color:#fff">苏ICP备19014585号-1</a></div>
  </div>
</template>
<script>
import api from "@/api/api";
import { apiGet, apiPost } from "@/fetch/api";
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      isShow: false
    };
  },
  computed: {
    ...mapState(["login", "userInfo", "m_id"])
  },
  methods: {
    ...mapActions(['setPrivateMask']),
    showewm(val) {
      this.isShow = val;
    },
    tolink(val) {
      if (val === "小镇概述") {
        const url = api.main.indexgetContent;
        const params = {
          merchantInfoId: this.m_id,
          isAll: true,
          page: 0,
          limit: 3,
          id: 371
        };
        localStorage.setItem("news_title", "小镇概述");
        apiGet(url, params).then(res => {
          if (Number(res.status) === 200) {
            this.$router.push(
              "/detail/news?pid=" +
                res.data.rows[0].id +
                "&menuId=" +
                res.data.rows[0].infoMenuId
            );
          }
        });
      }
      if (val === "乐园须知") {
        const url = api.main.indexgetContent;
        const params = {
          merchantInfoId: this.m_id,
          isAll: true,
          page: 0,
          limit: 3,
          id: 385
        };
        localStorage.setItem("news_title", "乐园须知");
        apiGet(url, params).then(res => {
          if (Number(res.status) === 200) {
            this.$router.push(
              "/detail/news?pid=" +
                res.data.rows[0].id +
                "&menuId=" +
                res.data.rows[0].infoMenuId
            );
          }
        });
      }
      if (val === "使用条款") {
        const url = api.main.indexgetContent;
        const params = {
          merchantInfoId: this.m_id,
          isAll: true,
          page: 0,
          limit: 3,
          id: 386
        };
        localStorage.setItem("news_title", "使用条款");
        apiGet(url, params).then(res => {
          if (Number(res.status) === 200) {
            this.$router.push(
              "/detail/news?pid=" +
                res.data.rows[0].id +
                "&menuId=" +
                res.data.rows[0].infoMenuId
            );
          }
        });
      }
      if (val === "法律声明") {
        const url = api.main.indexgetContent;
        const params = {
          merchantInfoId: this.m_id,
          isAll: true,
          page: 0,
          limit: 3,
          id: 387
        };
        localStorage.setItem("news_title", "法律声明 ");
        apiGet(url, params).then(res => {
          if (Number(res.status) === 200) {
            this.$router.push(
              "/detail/news?pid=" +
                res.data.rows[0].id +
                "&menuId=" +
                res.data.rows[0].infoMenuId
            );
          }
        });
      }
      if (val === "隐私政策") {
        const url = api.main.indexgetContent;
        const params = {
          merchantInfoId: this.m_id,
          isAll: true,
          page: 0,
          limit: 3,
          id: 388
        };
        localStorage.setItem("news_title", "隐私政策");
        apiGet(url, params).then(res => {
          if (Number(res.status) === 200) {
            this.$router.push(
              "/detail/news?pid=" +
                res.data.rows[0].id +
                "&menuId=" +
                res.data.rows[0].infoMenuId
            );
          }
        });
      }
      if (val === "在线预订") {
        this.setPrivateMask(true)
        return
        localStorage.setItem("news_title", "在线预订");
        this.$router.push("/detail/ticket?page=1&m_id=890&id=3424");
      }
      if (val === "小镇导览") {
        localStorage.setItem("news_title", "小镇导览");
        this.$router.push("/tourGuide?m_id=890");
      }
      if (val === "游玩攻略") {
        localStorage.setItem("news_title", "游玩攻略");
        this.$router.push({
          path:"/newslist",
          query:{
            m_id:this.m_id,
            pid:372
          }
        });
      }
      if (val === "小镇动态") {
        localStorage.setItem("news_title", "小镇动态");
        this.$router.push({
          path:"/newslist",
          query:{
            m_id:this.m_id,
            pid:376
          }
        });
      }
      if (val === "出行锦囊") {
        localStorage.setItem("news_title", "出行锦囊");
        this.$router.push({
          path:'/newslist',
          query:{
            m_id:this.m_id,
            pid:380
          }
        });

      }
    }
  }
};
</script>
<style lang="scss" scoped>
.car-footer {
  clear: both;
  width: 100%;
  background: url("../assets/images/carmer/ftbg.jpg") no-repeat left center;
  height: 296px;
  position: relative;
  .content {
    width: 1180px;
    margin: 0 auto;
    padding-top: 50px;
    display: flex;
    color: #fff;
    font-size: 12px;
    .cnt1 {
      width: 290px;
      margin-right: 115px;
      h3 {
        font-size: 18px;
        padding-bottom: 20px;
      }
      p {
        margin-top: 10px;
      }
    }
    .cnt2 {
      width: 260px;
      margin-right: 60p x;
      h3 {
        font-size: 18px;
        display: inline-block;
        border-bottom: 2px solid #fff;
        padding-bottom: 5px;
      }
      .gz-cnt {
        display: flex;
        margin-top: 20px;
        ul {
          width: 130px;
          display: block;
          li {
            margin-top: 10px;
            cursor: pointer;
          }
        }
      }
      .fx-cnt {
        padding-top: 20px;

        ul {
          display: flex;
        }
        li {
          margin-right: 20px;
        }
      }
    }
  }
  .cr-ft {
    height: 50px;
    width: 100%;
    text-align: center;
    line-height: 50px;
    text-align: center;
    color: #fff;
    position: absolute;
    bottom: 0;
    border-top: 1px solid #3a4f7c;
  }
  .erwm {
    margin-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/carmerFooter.vue